module.exports = __webpack_public_path__ + "img/resource2.791e6bbf.png";